import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ProductCaptureService } from '../../services/product-capture.service';
import { DcAlertService } from 'src/app/ui-kit/dc-alert/dc-alert.service';
import { takeUntil } from 'rxjs/operators';
import { GetErrorMessageFromResponse } from '../../utils/get-error-message-from-response';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-audit-modal',
  templateUrl: './audit-modal.component.html',
  styleUrls: ['./audit-modal.component.scss'],
})
export class AuditModalComponent implements OnInit, OnDestroy {
  loading: boolean;
  productId: string;
  productName: string;

  columns = [
    {
      name: 'Timestamp',
      prop: 'Timestamp',
      resizeable: false,
      draggable: false,
      minWidth: 180,
      maxWidth: 180,
    },
    {
      name: 'Description / Notes',
      prop: 'Description/Notes',
      resizeable: false,
      draggable: false,
      minWidth: 300,
      maxWidth: 300,
    },
    {
      name: 'User',
      prop: 'User',
      resizeable: false,
      draggable: false,
      minWidth: 180,
      maxWidth: 180,
    },
    {
      name: 'Record status',
      prop: 'Record status',
      resizeable: false,
      draggable: false,
      minWidth: 180,
      maxWidth: 180,
    },
    {
      name: 'Lifecycle status',
      prop: 'Lifecycle status',
      resizeable: false,
      draggable: false,
      minWidth: 180,
      maxWidth: 180,
    },
  ];
  rows: any[] = [];
  messages = {
    emptyMessage: 'No audit details found.',
    totalMessage: 'Total',
  };

  private destroy$ = new Subject<void>();

  constructor(
    private productCaptureService: ProductCaptureService,
    private dcAlertService: DcAlertService,
    private modal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.loading = true;
  }

  setDialogProps({ productId, productName }): void {
    this.productId = productId;
    this.productName = productName;

    this.productCaptureService
      .getProductStatusAudit(productId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (audit: any[]) => {
          this.rows = audit;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.dcAlertService.showAlert({
            type: 'danger',
            message: `Failed to load audit: ${GetErrorMessageFromResponse(
              error
            )} `,
          });
        }
      );
  }

  close: () => void = () => this.modal.dismiss('Close');

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
